export default __webpack_public_path__ + "static/media/zapper-logo-primary.a608f94f.svg";